module.exports = __webpack_public_path__ + "img/af.45742d5b.svg";